import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';

// Ponto único para dialogs de cadastro/edição — substitui os ~33 Dialog/DialogContent reimplementados por view.
const Modal = ({
  title,
  children,
  isOpen,
  onClose,
  maxWidth,
  fullWidth,
  fullScreen,
}) => (
  <Dialog
    open={isOpen}
    onClose={onClose}
    maxWidth={maxWidth}
    fullWidth={fullWidth}
    fullScreen={fullScreen}
    disableBackdropClick
  >
    <DialogContent style={{ paddingTop: 16 }}>
      <Grid container alignItems="flex-start" justify="space-between" spacing={16}>
        <Grid item xs={10}>
          <Typography variant="h5">{title}</Typography>
        </Grid>
        <Grid item xs={2} style={{ textAlign: 'right' }}>
          <Icon style={{ cursor: 'pointer' }} onClick={onClose}>
            close
          </Icon>
        </Grid>
      </Grid>

      {children}
    </DialogContent>
  </Dialog>
);

Modal.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),
  fullWidth: PropTypes.bool,
  fullScreen: PropTypes.bool,
};

Modal.defaultProps = {
  isOpen: false,
  onClose: () => {},
  maxWidth: 'lg',
  fullWidth: false,
  fullScreen: false,
};

export default Modal;
